import React, { useCallback, useEffect, useState } from "react";
import AppShell from "../../components/AppShell";
import { api } from "../../lib/api";
import StepUpPanel from "../../components/mfa/StepUpPanel";
import ModuleRow from "../../components/modules/ModuleRow";

// Founder Settings -> Modules. One row per registry module (services/module_registry.py): state, dependencies and
// the Activate / Deactivate switch (fresh step-up + reason, audited). Not implemented / externally blocked rows are
// shown truthfully and have no switch.
export default function ModulesSettings() {
  const [rows, setRows] = useState(null);
  const [status, setStatus] = useState(null);
  const [stepUp, setStepUp] = useState(null);
  const [err, setErr] = useState("");
  const [saved, setSaved] = useState("");
  const load = useCallback(() => api.get("/admin/modules").then((r) => setRows(r.data.modules))
    .catch((e) => setErr(e?.response?.data?.detail?.message || "Could not load modules.")), []);
  useEffect(() => { load(); api.get("/mfa/status").then((r) => setStatus(r.data)).catch(() => {}); }, [load]);
  const token = stepUp && stepUp.until > Date.now() ? stepUp.token : null;
  const hasFactor = !!status && (status.passkeys.length > 0 || status.totp.status === "active");
  const done = (msg) => { setSaved(msg); load(); };
  return (
    <AppShell title="Modules" subtitle="What is switched on for this workspace, and what is not built or blocked">
      <div className="mx-auto w-full max-w-[1000px] px-4 md:px-6 space-y-4" data-testid="modules-page">
        {err && <p role="alert" className="text-sm text-red-700" data-testid="modules-error">{err}</p>}
        {saved && <p role="status" className="text-sm text-green-800" data-testid="modules-saved">{saved}</p>}
        {!rows && !err && <p className="font-mono text-xs" data-testid="modules-loading">Loading…</p>}
        {status && !hasFactor && (
          <p className="text-sm" data-testid="modules-needs-factor">Set up a passkey or authenticator app first. Changing a module needs you to confirm it's you.</p>
        )}
        {status && hasFactor && <StepUpPanel status={status} stepUp={stepUp} setStepUp={setStepUp} />}
        {rows && (
          <ul className="space-y-3" data-testid="modules-list">
            {rows.map((m) => <ModuleRow key={m.key} m={m} token={token} onDone={done} />)}
          </ul>
        )}
      </div>
    </AppShell>
  );
}
